"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonColumns = exports.GooglePlayIcon = exports.AppStoreIcon = exports.ButtonsGrid = exports.Title = exports.Root = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _utils = require("../../utils");

var _Icons = require("../Icons");

var _Grid = require("../Grid");

var footerStyle = _utils.componentToken.footer;
var footerMainStyle = footerStyle.main;
var ICON_STYLES = (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  margin-right: 8px;\n"])));

var Root = _stylitas.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  padding-bottom: 64px;\n\n  ", "\n"])), footerMainStyle.links.color, _styleUtilities.media.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-top: 108px;\n  "]))));

exports.Root = Root;

var Title = _stylitas.styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  letter-spacing: ", "px;\n"])), footerMainStyle.baseText.color, footerStyle.fontFamily, footerMainStyle.baseText.md.fontSize, footerMainStyle.baseText.fontWeight, footerMainStyle.baseText.md.lineHeight, footerMainStyle.baseText.md.letterSpacing);

exports.Title = Title;
var ButtonsGrid = (0, _stylitas.styled)(_Grid.Grid)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-top: 24px;\n\n  ", "\n"])), _styleUtilities.media.md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    margin-top: 20px;\n  "]))));
exports.ButtonsGrid = ButtonsGrid;
var AppStoreIcon = (0, _stylitas.styled)(_Icons.AppStore)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), ICON_STYLES);
exports.AppStoreIcon = AppStoreIcon;
var GooglePlayIcon = (0, _stylitas.styled)(_Icons.GooglePlay)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n"])), ICON_STYLES);
exports.GooglePlayIcon = GooglePlayIcon;
var buttonColumns = {
  xs: 'repeat(2, 1fr)',
  md: 'repeat(2, 1fr)'
};
exports.buttonColumns = buttonColumns;